import React, { useEffect, useState } from "react";

import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";

import notesConnect from "../../../services/notes/connector";
import Note from "../../../components/note/Note";
import { compose } from "redux";

import "../../../components/note/notes.scss";

const Notes = ({ notes, getNotesById, createNote, currentUser }) => {
  const [text, setText] = useState("");
  const noteType = "Regular";

  useEffect(() => {
    if (currentUser && currentUser.Id) {
      getNotesById(currentUser.Id, currentUser.Domain === "Savelend");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser?.Ssn]);

  const data = currentUser && notes[currentUser.Id];
  if (!currentUser) return <React.Fragment />;
  if (!data || data.fetching) return <LinearProgress />;
  if (data.error) return <div>{data.error}</div>;

  return (
    <React.Fragment>
      <div className="create-note">
        <TextField
          variant="outlined"
          label="New note"
          fullWidth
          multiline
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
        <br />
        <Button
          disabled={data.sending || !text}
          variant="contained"
          color="primary"
          onClick={addNote}
        >
          add note
        </Button>
        {data.sending && <LinearProgress />}
        <br />
      </div>
      {data.data &&
        data.data.map((note) => {
          return <Note {...note} key={note.Id} />;
        })}
    </React.Fragment>
  );

  function addNote() {
    const isInvestor = currentUser.Domain === "Savelend";
    createNote(currentUser.Id, text, noteType, isInvestor);
    setText("");
  }
};

function _Notes(props) {
  let client =
    props.currentUser.Domain === "Loanstep" ? "Borrower" : "Investor";
  return (
    <React.Fragment>
      <h4>{client} Notes</h4>
      <Notes {...props} />
    </React.Fragment>
  );
}

export default compose(notesConnect)(_Notes);
